import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from "@/components/ui/button";
import { ChevronLeft } from "lucide-react";

const GDPR = () => {
  return (
    <div className="min-h-screen bg-sonas-bg text-sonas-text p-6 lg:p-20">
      <div className="max-w-3xl mx-auto space-y-12">
        <Link to="/">
          <Button variant="ghost" className="gap-2 text-sonas-dim hover:text-sonas-text">
            <ChevronLeft size={16} /> Back to Grid
          </Button>
        </Link>
        
        <header className="space-y-4">
          <h1 className="text-5xl font-syne font-bold">GDPR Compliance</h1>
          <p className="text-sonas-muted">European General Data Protection Regulation (GDPR).</p>
        </header>

        <div className="prose prose-invert prose-sonas max-w-none">
          <p>Sonas Workspace operates as a Data Controller for our registered users within the European Economic Area (EEA).</p>

          <h2 className="text-2xl font-bold mt-8">1. Your Data Rights</h2>
          <ul className="list-disc pl-6 space-y-3">
            <li><strong>The Right to Access:</strong> You can request a full export of your account dossier, including all messages and project data.</li>
            <li><strong>The Right to Rectification:</strong> You may update your profile information at any time via the Architect Workspace settings.</li>
            <li><strong>The Right to Erasure:</strong> You can request a "Complete Node Purge," which permanently deletes your profile and all associated projects from our primary database and backups within 30 days.</li>
            <li><strong>The Right to Object:</strong> You may opt-out of system broadcasts and non-essential platform communications.</li>
          </ul>

          <h2 className="text-2xl font-bold mt-8">2. Legal Basis for Processing</h2>
          <p>We process your data primarily on the basis of **Contractual Necessity** (to provide the AI services you requested) and **Legitimate Interest** (to maintain platform security and prevent fraudulent use of AI credits).</p>

          <h2 className="text-2xl font-bold mt-8">3. Data Protection Officer</h2>
          <p>For any formal GDPR requests or inquiries, please contact our administration team via the official Discord community or support email.</p>
        </div>
      </div>
    </div>
  );
};

export default GDPR;